import { modifiyDocumentById, queryDocuments } from '../util/defectDBUtils'
import { product } from '@/interfaces/product'
import { BaseRequest } from '@/network/requests/BaseRequest'
import { $in, like } from '@/network/util/QueryBuilder'

export const productRequest = BaseRequest.build<product>('product')

export interface ProductSearchParam {
	name?: string // 按名称搜索
	updated?: Array<0 | 1> // 筛选是否上传
}

/**
 * @param pagesize 分页大小
 * @param page 页码
 * @param where 筛选条件
 * @param createdTimeSort 时间排序
 */
export function queryProduct(pagesize: number, page: number, where: ProductSearchParam, createdTimeSort: -1 | 1 = -1) {
	let filter: any = undefined
	if (where.name) {
		filter = {
			name: like(where.name),
		}
	}
	if (where.updated) {
		if (!filter) {
			filter = {}
		}
		filter.updated = $in(where.updated)
	}

	return productRequest.queryPage({
		page,
		pagesize,
		filter,
		sort: { created_time: createdTimeSort },
	})
}

/**
 * 设置产品的工艺参数组
 * @param productId 产品id
 * @param techGroupId 工艺参数组id
 * @param techGroupName 工艺参数组名称
 */
export function setProductTechGroup(productId: string, techGroupId: string, techGroupName: string) {
	return productRequest.modifyById(productId, {
		tech_group_id: techGroupId,
		tech_group_name: techGroupName,
	})
}

/**
 * 设置产品的缺陷检测等级文件，defectLevelFileId为上传文件成功后返回的文件id。
 * @param productId
 * @param defectLevelFileId
 */
export function setProductDefectLevelFile(productId: string, defectLevelFileId: string) {
	return productRequest.modifyById(productId, {
		defect_level_file_id: defectLevelFileId,
	})
}

/**
 * 保存产品。
 * @param data
 */
export function saveProduct(data: product) {
	var p: Promise<any>
	if (data._id) {
		p = productRequest.modifyById(data._id.$oid, data)
	} else {
		data.created_time = { $date: new Date().getTime() }
		data.updated = 0
		p = productRequest.upload(data)
	}

	return p
}
